import * as React from 'react'

const IconAdd = ({size = 24}) => (
  <svg width={size} height={size} viewBox="0 0 24 24">
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M12 4a1 1 0 0 1 1 1v6h6a1 1 0 1 1 0 2h-6v6a1 1 0 1 1-2 0v-6H5a1 1 0 1 1 0-2h6V5a1 1 0 0 1 1-1Z"
      clipRule="evenodd"
    />
  </svg>
)

export default IconAdd
